<template>
  <div v-if="loading">
    <spinner small />
  </div>
  <dropdown-menu-button v-else :direction="direction">
    <v-list>
      <v-list-item
        v-for="(action, idx) in folderActions"
        :key="idx"
        @click="$emit('action', action.action)"
      >
        <v-list-item-title>
          {{ action.text }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </dropdown-menu-button>
</template>

<script>
export default {
  name: 'LessonFolderControls',
  props: {
    folder: {},
    loading: Boolean,
    direction: String,
  },
  data() {
    return {
      actions: [
        {
          text: 'Restore',
          action: 'restoreFolder',
          check: () => this.folder.deleted_at,
        },
        {
          text: 'Edit',
          action: 'renameFolder',
          check: () => !this.folder.deleted_at && this.folder.editable,
        },
        {
          text: 'Share to Group',
          action: 'shareFolder',
          check: () => {
            const { deleted_at, editable, folder_id } = this.folder;
            return !deleted_at && editable && !folder_id;
          },
        },
        {
          text: 'Delete',
          action: 'remove',
          check: () => !this.folder.deleted_at && this.folder.deletable,
        },
      ],
    };
  },
  computed: {
    folderActions() {
      return this.actions.filter(({ check }) => check());
    },
  },
};
</script>
